import type { ReactNode } from "react";
import styles from "./Footer.module.scss";

export default function Footer({ children }: { children: ReactNode }) {
  return <footer className={styles.footer}>{children}</footer>;
}
